import { render, staticRenderFns } from "./TheSideBar.vue?vue&type=template&id=3edef474&scoped=true&"
import script from "./TheSideBar.vue?vue&type=script&lang=js&"
export * from "./TheSideBar.vue?vue&type=script&lang=js&"
import style0 from "./TheSideBar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TheSideBar.vue?vue&type=style&index=1&id=3edef474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edef474",
  null
  
)

export default component.exports